import { useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'

const useUserForm = function ({ currentUser = {} }, ref) {
  const {
    watch,
    control,
    register,
    formState: { errors },
    formState,
    getValues,
    trigger,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: currentUser,
  })

  if (ref) {
    useImperativeHandle(ref, () => ({
      getValues,
      trigger,
    }))
  }

  return {
    reset,
    watch,
    control,
    register,
    formState,
    errors,
    clearErrors,
  }
}

export default useUserForm
